import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  visit(event) {
    visit(event.currentTarget.value)
  }
}
